export enum ContactMethod {
    EMAIL = 'email',
    PHONE = 'phone',
}
